import React from "react";

function ContactForm() {
  return (
    <div>
      <style>
        {`
    .demirsan-contact-title {
      margin-bottom: 30px;
      text-align: left;
    }

    .demirsan-contact-title::before,
    .demirsan-contact-title::after {
      content: none !important;
      display: none !important;
    }

    .demirsan-contact-subtitle {
      margin: 0 0 10px;
      padding: 0;
      color: #df0a0a;
      font-size: 16px;
      font-weight: 600;
      line-height: 1.2;
      text-transform: uppercase;
    }

    .demirsan-contact-heading {
      margin: 0;
      color: #1c2539;
      font-size: 42px;
      font-weight: 700;
      line-height: 1.2;
    }

    @media (max-width: 767px) {
      .demirsan-contact-heading {
        font-size: 32px;
      }
    }
  `}
      </style>
      {/* İletişim alanı başlangıcı */}
      <div className="rts-contact-area contact-one">
        <div className="container">
          <div className="row align-items-center g-0">
            <div className="col-lg-4 col-md-12 col-sm-12 col-12">
              <div className="contact-image-one">
                <img src="/assets/images/contact/03.jpg" alt="İletişim" />
              </div>
            </div>

            <div className="col-lg-8 col-md-12 col-sm-12 col-12">
              <div className="contact-form-area-one">
                <div className="demirsan-contact-title">
                  <p className="demirsan-contact-subtitle">
                    Bizimle İletişime Geçin
                  </p>

                  <h2 className="demirsan-contact-heading">
                    Teklif Talep Edin
                  </h2>
                </div>

                <div id="form-messages" />

                <form id="contact-form" action="mailer.php" method="post">
                  <div className="name-email">
                    <input
                      type="text"
                      placeholder="Adınız Soyadınız"
                      name="name"
                      required
                    />

                    <input
                      type="email"
                      placeholder="E-posta Adresiniz"
                      name="email"
                      required
                    />
                  </div>

                  <input
                    type="text"
                    placeholder="Konu"
                    name="subject"
                    required
                  />

                  <textarea
                    placeholder="Mesajınızı Yazınız"
                    name="message"
                    required
                    defaultValue=""
                  />

                  <button type="submit" className="rts-btn btn-primary">
                    Mesaj Gönder
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* İletişim alanı bitişi */}
    </div>
  );
}

export default ContactForm;
